import { Controller } from "@hotwired/stimulus";

// The Schedule period navigator's popover inputs (TASK-293.3): a date, a month
// or a flag that moves the results frame to a different period while every
// other current param rides along. frame-filter can't do this — it appends
// form values as they are, and "Pick a date" has to become from/to (Agenda)
// or week (Planner).
//
//   data-controller="period-jump"
//   data-period-jump-frame-value="planner-results"
//   data-period-jump-url-value="/schedule"
//   data-period-jump-params-value='{"kind":"visits","status":["missed"]}'   (params to keep)
//   data-period-jump-span-value="14"                                    (Agenda only)
//
// Inputs: data-action="change->period-jump#date|week|month|flag", a flag also
// carries name + value attributes (a checkbox: checked sets, unchecked drops).
export default class extends Controller {
  static values = {
    frame: String,
    url: String,
    params: { type: Object, default: {} },
    span: { type: Number, default: 14 }
  };

  date(event) {
    const value = event.target.value;
    if (!value) return;
    const [y, m, d] = value.split("-").map(Number);
    const to = new Date(Date.UTC(y, m - 1, d + this.spanValue - 1));
    this.go({ from: value, to: to.toISOString().slice(0, 10) }, ["from", "to"]);
  }

  week(event) {
    if (event.target.value) this.go({ week: event.target.value }, ["week"]);
  }

  month(event) {
    if (event.target.value) this.go({ month: event.target.value }, ["month"]);
  }

  flag(event) {
    const input = event.target;
    this.go(input.checked ? { [input.name]: input.value } : {}, [input.name]);
  }

  go(set, drop) {
    const url = new URL(this.urlValue, window.location.origin);
    for (const [key, value] of Object.entries(this.paramsValue)) {
      if (drop.includes(key)) continue;
      if (Array.isArray(value)) value.forEach((v) => url.searchParams.append(`${key}[]`, v));
      else url.searchParams.append(key, value);
    }
    for (const [key, value] of Object.entries(set)) url.searchParams.set(key, value);

    // A frame's `src` swap never touches history; Turbo.visit with a frame and
    // action: "advance" renders into the frame AND pushes the URL, the same as
    // the toolbar's own advancing links.
    window.Turbo.visit(url.toString(), { frame: this.frameValue, action: "advance" });
  }
}
